import { createApp } from 'vue'

import { createPinia } from 'pinia'
const pinia = createPinia()

// add font awesome icons for use in Vue components
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons'
const fontAwesome = library.add(faCaretLeft, faCaretRight)

import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

import Channels from './components/communications/Channels.vue'
const channels = createApp({}).use(pinia).use(FloatingVue)
channels.component('channels', Channels)
channels.mount('#channels')

import ConsentedChannels from './components/communications/ConsentedChannels.vue'
const consentedChannels = createApp({}).use(pinia).use(FloatingVue)
consentedChannels.component('consented-channels', ConsentedChannels)
consentedChannels.mount('#consented_channels')

import LogCommunication from './components/communications/LogCommunication.vue'
const logCommunication = createApp({}).use(pinia)
logCommunication.component('log-communication', LogCommunication)
logCommunication.mount('#log_communication')

import CommLogs from './components/communications/CommLogs.vue'
const commLogs = createApp({}).use(pinia)
commLogs.component('comm-logs', CommLogs)
commLogs.mount('#comm_logs')

import Survey from './components/surveys/Survey.vue'
const survey = createApp({}).use(pinia).use(fontAwesome)
survey.component('survey', Survey)
survey.mount('#survey')

import SurveyResponse from './components/surveys/SurveyResponse.vue'
const surveyResponse = createApp({}).use(pinia).use(fontAwesome)
surveyResponse.component('survey-response', SurveyResponse)
surveyResponse.mount('#survey_response')

import CurrentRoleForm from './components/users/CurrentRoleForm.vue'
const currentRoleForm = createApp({})
currentRoleForm.component('current-role-form', CurrentRoleForm)
currentRoleForm.mount('#current-role-form')